import React from 'react';
import { RSAA } from 'redux-api-middleware';
import { FormattedMessage } from 'react-intl';
import { REQUEST, SUCCESS, FAILURE } from '@/modules/Requests';

import CountryRU from '@/assets/img/flags/RU.png';
import CountryEE from '@/assets/img/flags/EE.png';
import CountryFR from '@/assets/img/flags/FR.png';
import CountryIL from '@/assets/img/flags/IL.png';
import CountryCY from '@/assets/img/flags/CY.png';

import CountryIN from '@/assets/img/flags/IN.png';
import CountryKG from '@/assets/img/flags/KG.png';
import CountryAM from '@/assets/img/flags/AM.png';
import CountryBG from '@/assets/img/flags/BG.jpg';
import CountryUA from '@/assets/img/flags/UA.png';

import CountryDE from '@/assets/img/flags/DE.png';
import CountryUS from '@/assets/img/flags/US.png';
import CountryBY from '@/assets/img/flags/BY.jpg';
import CountryKZ from '@/assets/img/flags/KZ.jpg';
import CountryCH from '@/assets/img/flags/CH.jpg';

import CountryGB from '@/assets/img/flags/GB.jpg';
import CountryRO from '@/assets/img/flags/RO.jpg';
import CountryLB from '@/assets/img/flags/LB.png';
import CountryLT from '@/assets/img/flags/LT.jpg';
import CountryLV from '@/assets/img/flags/LV.png';
import CountryAZ from '@/assets/img/flags/AZ.jpg';

import CountryTJ from '@/assets/img/flags/TJ.png';
// import CountryIQ from '@/assets/img/flags/IQ.png';
import CountrySE from '@/assets/img/flags/SE.jpg';
import CountryKR from '@/assets/img/flags/KR.png';
import CountryBE from '@/assets/img/flags/BE.png';
import CountryCN from '@/assets/img/flags/CN.png';

import CountryUZ from '@/assets/img/flags/UZ.png';
import CountrySA from '@/assets/img/flags/SA.png';
import CountryTQ from '@/assets/img/flags/TQ.png';
import CountryIT from '@/assets/img/flags/IT.png';
import CountryTH from '@/assets/img/flags/TH.png';

export const REQUEST_GET_PARTICIPATION = 'REQUEST_GET_PARTICIPATION';
export const REQUEST_START_PARTICIPATION = 'REQUEST_START_PARTICIPATION';
export const SET_PARTICIPANT = 'olimpic/SET_PARTICIPANT';
export const REQUEST_PARTICIPATE = 'REQUEST_PARTICIPATE';
export const REQUEST_OLIMPIC_CREATE = 'REQUEST_OLIMPIC_CREATE';
export const REQUEST_GET_OLIMPIC = 'REQUEST_GET_OLIMPIC';
export const REQUEST_GET_OLIMPIC_ACTIVE = 'REQUEST_GET_OLIMPIC_ACTIVE';
export const SET_OLIMPIC = 'SET_OLIMPIC';
export const SET_ACTIVE = 'SET_ACTIVE';
export const REQUEST_OLIMPIC_DELETE = 'REQUEST_OLIMPIC_DELETE';
export const OLIMPIC_FORM = 'OLIMPIC_FORM';
export const OLIMPIC_PARTICIPANT_FORM = 'OLIMPIC_PARTICIPANT_FORM';
export const REQUEST_OLIMPIC_LIST = 'REQUEST_OLIMPIC_LIST';
export const SET_OLIMPIC_LIST = 'SET_OLIMPIC_LIST';
export const REQUEST_OLIMPIC_EDIT = 'REQUEST_OLIMPIC_EDIT';
export const REQUEST_SAVE_OLIMPIC_RESULT = 'REQUEST_SAVE_OLIMPIC_RESULT';
export const REQUEST_GET_OLIMPIC_RATING = 'REQUEST_GET_OLIMPIC_RATING';
export const REQUEST_GET_OLIMPIC_RANKING = 'REQUEST_GET_OLIMPIC_RANKING';
export const REQUEST_GET_OLIMPIC_RESULTS = 'REQUEST_GET_OLIMPIC_RESULTS';
export const REQUEST_PARTICIPANT_EDIT = 'REQUEST_PARTICIPANT_EDIT';
export const REQUEST_GET_OLIMPIC_PARTICIPATIONS =
  'REQUEST_GET_OLIMPIC_PARTICIPATIONS';
export const REQUEST_GET_PARTICIPANT = 'REQUEST_GET_PARTICIPANT';
export const REQUEST_ADD_PARTICIPATION = 'REQUEST_ADD_PARTICIPATION';
export const REQUEST_GET_OLIMPIC_PARTICIPANTS =
  'REQUEST_GET_OLIMPIC_PARTICIPANTS';
export const REQUEST_DELETE_OLIMPIC_PARTICIPANTS =
  'REQUEST_DELETE_OLIMPIC_PARTICIPANTS';
export const REQUEST_REQUIRE_PAID = 'REQUEST_REQUIRE_PAID';

export const REQUEST_EXPORT_PARTICIPANTS = 'REQUEST_EXPORT_PARTICIPANTS';

export const REQUEST_GET_TEMPLATES = 'REQUEST_GET_TEMPLATES';
export const REQUEST_TEMPLATE_DELETE = 'REQUEST_TEMPLATE_DELETE';
export const REQUEST_TEMPLATE_CREATE = 'REQUEST_TEMPLATE_CREATE';
export const TEMPLATE_FORM = 'TEMPLATE_FORM';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';
export const GET_TEMPLATE = 'GET_TEMPLATE';
export const REQUEST_GET_TEMPLATES_SELECT = 'REQUEST_GET_TEMPLATES_SELECT';
export const REQUEST_GET_MEMORY_SAMPLES = 'REQUEST_GET_MEMORY_SAMPLES';
export const REQUEST_GET_MAINTAINERS = 'REQUEST_GET_MAINTAINERS';
export const REQUEST_CREATE_MAINTAINERS = 'REQUEST_CREATE_MAINTAINERS';
export const REQUEST_GET_OLIMPIC_MAINTAINERS =
  'REQUEST_GET_OLIMPIC_MAINTAINERS';
export const REQUEST_EDIT_MAINTAINER = 'REQUEST_EDIT_MAINTAINER';
export const REQUEST_DELETE_MAINTAINER = 'REQUEST_DELETE_MAINTAINER';
export const REQUEST_GET_MAINTAINER = 'REQUEST_GET_MAINTAINER';
export const REQUEST_OLIMPIC_STAGE_DATA = 'REQUEST_OLIMPIC_STAGE_DATA';
export const SET_OLIMPIC_STAGE_DATA = 'SET_OLIMPIC_STAGE_DATA';

const host = process.env.BACKEND_URL;

// Init state
const initialState = {
  participant: null,
  list: [],
};

// types

export const TYPE = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  SAMA: 'sama',
  PAMA_OFFLINE: 'pama_offline',
};

export const types = [
  {
    value: TYPE.ONLINE,
    label: <FormattedMessage id="ONLINE" />,
  },
  {
    value: TYPE.OFFLINE,
    label: <FormattedMessage id="OFFLINE_OLIMPIC" />,
  },
  {
    value: TYPE.SAMA,
    label: <FormattedMessage id="SAMA_OLIMPIC" />,
  },
  {
    value: TYPE.PAMA_OFFLINE,
    label: <FormattedMessage id="PAMA_OFFLINE_OLIMPIC" />,
  },
];

// Reducer
const olimpicReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PARTICIPANT:
    case SET_OLIMPIC:
    case SET_OLIMPIC_LIST:
    case SET_OLIMPIC_STAGE_DATA:
      return {
        ...state,
        [action.meta]: action.payload,
      };
    case SET_ACTIVE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export const fetchList = formData => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/data?${Object.entries(formData)
      .reduce((acc, [key, value]) => {
        acc.push(`${key}=${value}`);
        return acc;
      }, [])
      .join('&')}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_OLIMPIC_LIST,
      },
    })),
  },
});

/**
 * Загрузка данных отдельного этапа олимпиады (используется для "Распечатать все этапы")
 * @param {object} formData - параметры этапа
 * @param {string} stageId - уникальный идентификатор этапа (например, "AddA", "MultiA")
 */
export const fetchOlimpicStageData = (formData, stageId) => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/data?${Object.entries(formData)
      .reduce((acc, [key, value]) => {
        acc.push(`${key}=${value}`);
        return acc;
      }, [])
      .join('&')}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: `${REQUEST_OLIMPIC_STAGE_DATA}_${stageId}`,
      },
    })),
  },
});

export const fetchOlimpicRating = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/${id ? `${id}/` : ''}rating`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_OLIMPIC_RATING,
      },
    })),
  },
});

export const fetchOlimpicRanking = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/${id ? `${id}/` : ''}ranking`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_OLIMPIC_RANKING,
      },
    })),
  },
});

export const fetchParticipation = () => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/participant`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_PARTICIPATION,
      },
    })),
  },
});

export const fetchOlimpicStart = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/${id}/start`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_START_PARTICIPATION,
      },
    })),
  },
});

export const fetchResults = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/${id ? `${id}/` : ''}results`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_OLIMPIC_RESULTS,
      },
    })),
  },
});

export const fetchStats = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/stats/${id}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_PARTICIPATION,
      },
    })),
  },
});

export const fetchAddParticipation = (formData, id) => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/${id ? `${id}/` : ''}participants`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_ADD_PARTICIPATION,
      },
    })),
  },
});

export const fetchEditParticipants = formData => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/participants/edit`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_ADD_PARTICIPATION,
      },
    })),
  },
});

export const fetchClearParticipant = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/participant/clear/${id}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_ADD_PARTICIPATION,
      },
    })),
  },
});

export const fetchParticipant = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/participant/${id}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_PARTICIPANT,
      },
    })),
  },
});

export const fetchParticipate = (id, formData) => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/${id ? `${id}/` : ''}participate`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_PARTICIPATE,
      },
    })),
  },
});

export const fetchParticipantEdit = (id, formData) => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/participant/edit/${id}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_PARTICIPANT_EDIT,
      },
    })),
  },
});

export const fetchRequirePaid = data => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/paid`,
    method: 'POST',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_REQUIRE_PAID,
      },
    })),
  },
});

export const fetchSaveOlimpicResult = (id, view, formData) => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/${id ? `${id}/` : ''}save/${view}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_SAVE_OLIMPIC_RESULT,
      },
    })),
  },
});

export const fetchOlimpicCreate = formData => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/settings/create`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_OLIMPIC_CREATE,
      },
    })),
  },
});

export const fetchOlimpicEdit = (id, formData) => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/settings/edit/${id}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_OLIMPIC_EDIT,
      },
    })),
  },
});

export const fetchOlimpic = formData => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/settings`,
    method: 'GET',
    body: JSON.stringify(formData),
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_OLIMPIC,
      },
    })),
  },
});

export const fetchActiveOlimpics = () => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/active`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_OLIMPIC_ACTIVE,
      },
    })),
  },
});

export const fetchOlimpicParticipants = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/${id ? `${id}/` : ''}participants`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_OLIMPIC_PARTICIPANTS,
      },
    })),
  },
});

export const fetchUsersParticipants = () => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/offline/participants/users`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_OLIMPIC_PARTICIPANTS,
      },
    })),
  },
});

export const fetchUsersParticipantsPama = () => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/pama_offline/participants/users`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_OLIMPIC_PARTICIPANTS,
      },
    })),
  },
});

export const fetchDeleteParticipants = (id, data) => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/${id}/participants`,
    method: 'DELETE',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_DELETE_OLIMPIC_PARTICIPANTS,
      },
    })),
  },
});

export const fetchExportParticipants = () => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/offline/participants/export/`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_EXPORT_PARTICIPANTS,
      },
    })),
  },
});

export const fetchExportParticipantsPama = () => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/pama_offline/participants/export/`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_EXPORT_PARTICIPANTS,
      },
    })),
  },
});

export const fetchOlimpicParticipations = () => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/participations`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_OLIMPIC_PARTICIPATIONS,
      },
    })),
  },
});

export const fetchOlimpicDelete = formData => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/settings/delete`,
    method: 'DELETE',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_OLIMPIC_DELETE,
      },
    })),
  },
});

export const fetchTemplates = () => ({
  [RSAA]: {
    endpoint: `${host}/olimpictemplates/list`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_TEMPLATES,
      },
    })),
  },
});

export const fetchTemplateDelete = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpictemplates/delete/${id}`,
    method: 'DELETE',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: 'REQUEST_TEMPLATE_DELETE',
      },
    })),
  },
});

export const fetchTemplateCreate = formData => ({
  [RSAA]: {
    endpoint: `${host}/olimpictemplates/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_TEMPLATE_CREATE,
      },
    })),
  },
});

export const fetchTemplate = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpictemplates/template/${id}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: GET_TEMPLATE,
      },
    })),
  },
});

export const fetchUpdateTemplate = (id, form) => ({
  [RSAA]: {
    endpoint: `${host}/olimpictemplates/edit/${id}`,
    method: 'POST',
    body: JSON.stringify(form),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: UPDATE_TEMPLATE,
      },
    })),
  },
});

export const fetchTemplatesSelectList = () => ({
  [RSAA]: {
    endpoint: `${host}/olimpictemplates/select-list`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: { request: REQUEST_GET_TEMPLATES_SELECT },
    })),
  },
});

/**
 * Получить массив чисел для "Числа"
 * @param {number} stage - номер этапа (1, 2 или 3)
 */
export const fetchMemorySamples = stage => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/memory-samples`,
    method: 'POST',
    body: JSON.stringify({ stage }),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_MEMORY_SAMPLES,
      },
    })),
  },
});

export const fetchGetMaintainers = participantId => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/maintainers/${participantId}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_MAINTAINERS,
      },
    })),
  },
});

export const fetchCreateMaintainers = formData => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/maintainers`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_CREATE_MAINTAINERS,
      },
    })),
  },
});

export const fetchGetOlimpicMaintainers = olimpicType => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/${olimpicType}/maintainers`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_OLIMPIC_MAINTAINERS,
      },
    })),
  },
});

export const fetchEditMaintainer = (id, formData) => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/maintainers/${id}`,
    method: 'PUT',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_EDIT_MAINTAINER,
      },
    })),
  },
});

export const fetchDeleteMaintainer = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/maintainers/${id}`,
    method: 'DELETE',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_DELETE_MAINTAINER,
      },
    })),
  },
});

export const fetchGetMaintainer = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/maintainer/${id}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: { request: REQUEST_GET_MAINTAINER },
    })),
  },
});

export default olimpicReducer;

export const settings = [
  {
    name: 'A13',
    years: [2025, 2024, 2023, 2022, 2021, 2020, 2019], // поменять на возраст
    type: 'student',
    level: 16,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1D5RNF',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D3RNF',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1-2D4RNF',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddD',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D3RNF',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddE',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D4RNF',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddF',
        type: 'Card',
        title: 'CARD',
        short: '1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'A12',
    years: [2025, 2024, 2023, 2022, 2021, 2020, 2019],
    type: 'student',
    level: 15,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1D6RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D3RNF',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1-2D5RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddD',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D4RNF',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddE',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D5RNF',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddF',
        type: 'Card',
        title: 'CARD',
        short: '2D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'A11',
    years: [2025, 2024, 2023, 2022, 2021, 2020, 2019],
    type: 'student',
    level: 26,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1D8RF10',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D4RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1-2D5RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddD',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D5RNF',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddE',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D3F5',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddF',
        type: 'Card',
        title: 'CARD',
        short: '2D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'A9', // была AS
    years: [2025, 2024, 2023, 2022, 2021, 2020, 2019],
    type: 'student',
    level: 14,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D4R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1D8R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '2D*1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D4R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddD',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D5R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'AP',
    years: [2025, 2024, 2023, 2022, 2021, 2020, 2019],
    type: 'student',
    level: 25,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D6R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '3D*1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '3D/1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D6R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },

      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'B12',
    years: [2018, 2017],
    type: 'student',
    level: 23,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1D6RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D3RNF',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1-2D5RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddD',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D4RNF',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddE',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D5RNF',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddF',
        type: 'Card',
        title: 'CARD',
        short: '2D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'B10',
    years: [2018, 2017],
    type: 'student',
    level: 22,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1-2D6R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D4RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddD',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D5RF5',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddE',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D4RF10',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiDivision',
        type: 'MultiDivision',
        title: 'MULTIDIVISION',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'B8', // была BS
    years: [2018, 2017],
    type: 'student',
    level: 21,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'Multi',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '3D*1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'Division',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '3D/1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D6R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1-2D4R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiDivision',
        type: 'MultiDivision',
        title: 'MULTIDIVISION',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'BP',
    years: [2018, 2017],
    type: 'student',
    level: 27,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2-3D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '2D*2D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '4D/1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D7R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'C12',
    years: [2016, 2015],
    type: 'student',
    level: 20,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1D6RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D4RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1-2D5RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddD',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D5RNF',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'C10',
    years: [2016, 2015],
    type: 'student',
    level: 19,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1-2D6R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D4RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddD',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D5RF5',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddE',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D4RF10',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiDivision',
        type: 'MultiDivision',
        title: 'MULTIDIVISION',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'C8',
    years: [2016, 2015],
    type: 'student',
    level: 18,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'Multi',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '3D*1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'Division',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '3D/1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D6R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1-2D4R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiDivision',
        type: 'MultiDivision',
        title: 'MULTIDIVISION',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'C7', // была CS
    years: [2016, 2015],
    type: 'student',
    level: 17,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2-3D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'Multi',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '2D*2D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'Division',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '4D/1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D7R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1-2D5R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiDivision',
        type: 'MultiDivision',
        title: 'MULTIDIVISION',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'CP',
    years: [2016, 2015],
    type: 'student',
    level: 28,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2-4D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '2D*3D, 3D*2D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '3-4D2/D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '2D4R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        short: '2D*1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        short: '3D/1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'D12',
    years: [2014, 2013],
    type: 'student',
    level: 12,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1D6RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D4RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1-2D5RF5',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddD',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D5RNF',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'D9',
    years: [2014, 2013],
    type: 'student',
    level: 29,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D4R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1D8R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '2D*1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D5R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'D7',
    years: [2014, 2013],
    type: 'student',
    level: 17,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2-3D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'Multi',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '2D*2D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'Division',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '4D/1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D7R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1-2D5R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiDivision',
        type: 'MultiDivision',
        title: 'MULTIDIVISION',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'D6', // была DS
    years: [2014, 2013],
    type: 'student',
    level: 24,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2-3D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '3D*2D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '4D/2D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '2D4R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        short: '2D*1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        short: '3D/1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'DP',
    years: [2014, 2013],
    type: 'student',
    level: 10,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '3-4D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '2D*4D, 4D*2D, 3D*3D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '4-5D/2D, 4-5D/3D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '2D6R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        short: '3D*1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        short: '3D/1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'E9',
    years: [2012, 2011, 2010, 2009, 2008],
    type: 'student',
    level: 7,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2D4R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1D8R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '2D*1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddD',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D5R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiC',
        type: 'Multi',
        title: 'MULTIPLICATION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'E7',
    years: [2012, 2011, 2010, 2009, 2008],
    type: 'student',
    level: 6,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2-3D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '2D*2D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'Division',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '4D/1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D7R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1-2D5R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'MultiDivision',
        title: 'MULTIDIVISION',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'E5', // была ES
    years: [2012, 2011, 2010, 2009, 2008],
    type: 'student',
    level: 5,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '3-4D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '3D*3D, 4D*2D, 2D*4D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '5D/2-3D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '2D6R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        short: '3D*1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        short: '3D/1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'EP',
    years: [2012, 2011, 2010, 2009, 2008],
    type: 'student',
    level: 8,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '4-5D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '4D*3D, 5D*2D, 2D*5D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '5-6D/2-3D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '2D8R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        short: '2-3D*1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        short: '3-4D/1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'F3',
    years: [],
    type: 'student',
    level: 3,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1-2D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '1D8R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '2D*1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D5R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION_TABLE',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'F2',
    years: [],
    type: 'student',
    level: 2,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '2-3D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'Multi',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '2D*2D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'Division',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '4D/1D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1D7R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '1-2D5R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'MultiDivision',
        title: 'MULTIDIVISION',
        samples: 60,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'F1',
    years: [],
    type: 'student',
    level: 1,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        short: '3-4D10R',
        samples: 40,
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        short: '3D*3D, 4D*2D, 2D*4D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        short: '4-5D/2D',
        samples: 40,
        time: 3,
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        short: '2D6R',
        samples: 40,
        time: 1,
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        short: '3D*1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        short: '3D/1D',
        samples: 40,
        time: 1,
        score: 5,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
];

export const syllabusLevels = {
  A13: 13,
  A12: 12,
  A11: 11,
  AS: 9,
  A9: 9,
  AP: 8,
  B12: 12,
  B10: 10,
  BS: 8,
  B8: 8,
  BP: 7,
  C12: 12,
  C10: 10,
  C8: 8,
  CS: 7,
  C7: 7,
  CP: 6,
  D12: 12,
  D9: 9,
  D7: 7,
  DS: 6,
  D6: 6,
  DP: 5,
  E9: 9,
  E7: 7,
  ES: 5,
  E5: 5,
  EP: 4,
  F1: 5,
  F2: 7,
  F3: 9,
};

export const countries = [
  {
    value: 'AZ',
    label: 'Азербайджан',
    image: CountryAZ,
  },
  {
    value: 'AM',
    label: 'Армения',
    image: CountryAM,
  },
  {
    value: 'BY',
    label: 'Беларусь',
    image: CountryBY,
  },
  {
    value: 'BE',
    label: 'Бельгия',
    image: CountryBE,
  },
  {
    value: 'BG',
    label: 'Болгария',
    image: CountryBG,
  },
  {
    value: 'GB',
    label: 'Великобритания',
    image: CountryGB,
  },
  {
    value: 'DE',
    label: 'Германия',
    image: CountryDE,
  },
  {
    value: 'IL',
    label: 'Израиль',
    image: CountryIL,
  },
  {
    value: 'IN',
    label: 'Индия',
    image: CountryIN,
  },
  {
    value: 'IT',
    label: 'Италия',
    image: CountryIT,
  },
  {
    value: 'KZ',
    label: 'Казахстан',
    image: CountryKZ,
  },
  {
    value: 'CY',
    label: 'Кипр',
    image: CountryCY,
  },
  {
    value: 'KG',
    label: 'Киргизия',
    image: CountryKG,
  },
  {
    value: 'CN',
    label: 'Китай',
    image: CountryCN,
  },
  {
    value: 'KR',
    label: 'Корея',
    image: CountryKR,
  },
  {
    value: 'LB',
    label: 'Ливан',
    image: CountryLB,
  },
  {
    value: 'LT',
    label: 'Литва',
    image: CountryLT,
  },
  {
    value: 'LV',
    label: 'Латвия',
    image: CountryLV,
  },
  {
    value: 'RU',
    label: 'Россия',
    image: CountryRU,
  },
  {
    value: 'RO',
    label: 'Румыния',
    image: CountryRO,
  },
  {
    value: 'US',
    label: 'США',
    image: CountryUS,
  },
  {
    value: 'SA',
    label: 'Саудовская Аравия',
    image: CountrySA,
  },
  {
    value: 'TJ',
    label: 'Таджикистан',
    image: CountryTJ,
  },
  {
    value: 'TH',
    label: 'Таиланд',
    image: CountryTH,
  },
  {
    value: 'TQ',
    label: 'Турция',
    image: CountryTQ,
  },
  /*
  {
    value: 'IQ',
    label: 'Ирак',
    image: CountryIQ
  },
  */
  {
    value: 'UZ',
    label: 'Узбекистан',
    image: CountryUZ,
  },
  {
    value: 'UA',
    label: 'Украина',
    image: CountryUA,
  },
  {
    value: 'FR',
    label: 'Франция',
    image: CountryFR,
  },
  {
    value: 'CH',
    label: 'Швейцария',
    image: CountryCH,
  },
  {
    value: 'SE',
    label: 'Швеция',
    image: CountrySE,
  },
  {
    value: 'EE',
    label: 'Эстония',
    image: CountryEE,
  },
];

export const headers = {
  A13: [
    'Сложение и вычитание на абакусе 1D5RNF, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание на абакусе 2D3RNF зеркальные, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание Ментально 1D3RNF, 40 примеров, 1 минута, 10 баллов',
    'Образ числа 1D, 40 примеров, 1 минута, 10 Баллов',
  ],
  A12: [
    'Сложение и вычитание на абакусе 1D6RF5, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание на абакусе 2D3RNF, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание Ментально 1D4RNF, 40 примеров, 1 минута, 10 баллов',
    'Образ числа 2D, 40 примеров, 1 минута, 10 баллов',
  ],
  A11: [
    'Сложение и вычитание на абакусе 1D8RF10, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание на абакусе 2D4RF5, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание Ментально 1D5RNF, 40 примеров, 1 минута, 10 баллов',
    'Сложение и вычитание Ментально 1D3F5, 40 примеров, 1 минута, 10 баллов',
  ],
  AS: [
    'Сложение и вычитание на абакусе 2D4R, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание на абакусе 1D8R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 2D*1D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 1D4R, 40 примеров, 1 минута, 10 баллов',
    'Таблица умножения, 40 примеров, 1 минута, 5 баллов',
    'Сложение и вычитание Ментально 1D5R, 40 примеров, 1 минута, 10 баллов',
  ],
  AP: [
    'Сложение и вычитание на абакусе 2D6R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 3D*1D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 3D/1D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 1D6R, 40 примеров, 1 минутa, 10 баллов',
    'Таблица умножения, 40 примеров, 1 минутa, 5 баллов',
    'Таблица деления, 40 примеров, 1 минутa, 5 баллов',
  ],
  B12: [
    'Сложение и вычитание на абакусе 1D6RF5, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание на абакусе 2D3RNF, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание Ментально 1D4RNF, 40 примеров, 1 минута, 10 баллов',
    'Образ числа 2D, 40 примеров, 1 минута, 10 баллов',
  ],
  B10: [
    'Сложение и вычитание на абакусе 1D10R, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание на абакусе 2D4RF5, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание Ментально 1D5RF5, 40 примеров, 1 минута, 10 баллов',
    'Сложение и вычитание Ментально 1D4RF10, 40 примеров, 1 минута, 10 баллов',
  ],
  BS: [
    'Сложение и вычитание на абакусе 2D10R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 3D*1D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 3D/1D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 1D6R, 40 примеров, 1 минута, 10 баллов',
    'Сложение и вычитание Ментально 1-2D4R, 40 примеров, 1 минута, 10 баллов',
    'Таблица умножения и деления, 40 примеров, 1 минута, 5 баллов',
  ],
  BP: [
    'Сложение и вычитание на абакусе 2-3D10R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 2D*2D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 4D/1D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 1D7R, 40 примеров, 1 минутa, 10 баллов',
    'Таблица умножения, 40 примеров, 1 минутa, 5 баллов',
    'Таблица деления, 40 примеров, 1 минутa, 5 баллов',
  ],
  C12: [
    'Сложение и вычитание на абакусе 1D6RF5, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание на абакусе 2D3RNF, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание Ментально 1D4RNF, 40 примеров, 1 минута, 10 баллов',
    'Образ числа 2D, 40 примеров, 1 минута, 10 баллов',
  ],
  C10: [
    'Сложение и вычитание на абакусе 1D10R, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание на абакусе 2D4RF5, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание Ментально 1D5RF5, 40 примеров, 1 минута, 10 баллов',
    'Сложение и вычитание Ментально 1D4RF10, 40 примеров, 1 минута, 10 баллов',
    'Таблица умножения и деления, 40 примеров, 1 минута, 5 баллов',
  ],
  C8: [
    'Сложение и вычитание на абакусе 2D10R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 3D*1D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 3D/1D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 1D6R, 40 примеров, 1 минута, 10 баллов',
    'Сложение и вычитание Ментально 1-2D4R, 40 примеров, 1 минута, 10 баллов',
    'Таблица умножения и деления, 40 примеров, 1 минута, 5 баллов',
  ],
  CS: [
    'Сложение и вычитание на абакусе 2-3D10R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 2D*2D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 4D/1D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 1D7R, 40 примеров, 1 минута, 10 баллов',
    'Сложение и вычитание Ментально 1-2D5R, 40 примеров, 1 минута, 10 баллов',
    'Таблица умножения и деления, 40 примеров, 1 минута, 5 баллов.',
  ],
  CP: [
    'Сложение и вычитание на абакусе 2-4D10R, десятичные дроби, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 2D*3D, 3D*2D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 3-4D2/D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 2D4R, 40 примеров, 1 минутa, 10 баллов',
    'Умножение ментально 2D*1D, 40 примеров, 1 минута, 5 баллов',
    'Деление ментально 3D/1D, 40 примеров, 1 минута, 5 баллов',
  ],
  D12: [
    'Сложение и вычитание на абакусе 1D6RF5, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание на абакусе 2D3RNF, 40 примеров, 3 минуты, 10 баллов',
    'Таблица умножения и деления, 40 примеров, 1 минута, 5 баллов',
    'Сложение и вычитание Ментально 1D4RNF, 40 примеров, 1 минута, 10 баллов',
    'Образ числа 2D, 40 примеров, 1 минута, 10 баллов',
  ],
  D10: [
    'Сложение и вычитание на абакусе 1D10R, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание на абакусе 2D4RF5, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание Ментально 1D5RF5, 40 примеров, 1 минута, 10 баллов',
    'Сложение и вычитание Ментально 1D4RF10, 40 примеров, 1 минута, 10 баллов',
    'Таблица умножения и деления, 40 примеров, 1 минута, 5 баллов',
  ],
  D9: [
    'Сложение и вычитание на абакусе 2D4R, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание на абакусе 1D8R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 2D*1D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 1D4R, 40 примеров, 1 минута, 10 баллов',
    'Таблица умножения, 40 примеров, 1 минута, 5 баллов',
    'Сложение и вычитание Ментально 1D5R, 40 примеров, 1 минута, 10 баллов',
  ],
  D7: [
    'Сложение и вычитание на абакусе 2-3D10R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 2D*2D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 4D/1D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 1D7R, 40 примеров, 1 минута, 10 баллов',
    'Сложение и вычитание Ментально 1-2D5R, 40 примеров, 1 минута, 10 баллов',
    'Таблица умножения и деления, 40 примеров, 1 минута, 5 баллов',
  ],
  DS: [
    'Сложение и вычитание на абакусе 2-3D10R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 3D*2D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 4D/2D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 2D4R, 40 примеров, 1 минута, 10 баллов',
    'Ментальное умножение 2D*1D, 40 примеров, 1 минута, 5 баллов',
    'Ментальное деление 3D/1D, 40 примеров, 1 минута, 5 баллов',
  ],
  DP: [
    'Сложение и вычитание на абакусе 3-4D10R, десятичные дроби, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 2D*4D, 4D*2D, 3D*3D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 4-5D/2D, 4-5D/3D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 2D6R, 40 примеров, 1 минута, 10 баллов',
    'Ментальное умножение 3D*1D, 40 примеров, 1 минута, 5 баллов',
    'Ментальное деление 3D/1D, 40 примеров, 1 минута, 5 баллов',
  ],
  E9: [
    'Сложение и вычитание на абакусе 2D4R, 40 примеров, 3 минуты, 10 баллов',
    'Сложение и вычитание на абакусе 1D8R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 2D*1D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 1D4R, 40 примеров, 1 минута, 10 баллов',
    'Таблица умножения, 40 примеров, 1 минута, 5 баллов',
    'Сложение и вычитание Ментально 1D5R, 40 примеров, 1 минута, 10 баллов',
  ],
  E7: [
    'Сложение и вычитание на абакусе 2-3D10R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 2D*2D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 4D/1D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 1D7R, 40 примеров, 1 минута, 10 баллов',
    'Сложение и вычитание Ментально 1-2D5R, 40 примеров, 1 минута, 10 баллов',
    'Таблица умножения и деления, 40 примеров, 1 минута, 5 баллов',
  ],
  ES: [
    'Сложение и вычитание на абакусе 3-4D10R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 3D*3D, 4D*2D, 2D*4D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 5D/2-3D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 2D6R, 40 примеров, 1 минута, 10 баллов',
    'Ментальное умножение 3D*1D, 40 примеров, 1 минута, 5 баллов',
    'Ментальное деление 3D/1D, 40 примеров, 1 минута, 5 баллов',
  ],
  F3: [
    'Сложение и вычитание на абакусе 1-2D10R, 40 примеров, 3 минуты, 10 баллов',
    'Таблица умножения, 40 примеров, 1 минута, 5 баллов',
    'Таблица деления, 40 примеров, 1 минута, 5 баллов',
    'Сложение и вычитание Ментально 1D6R, 40 примеров, 1 минута, 10 баллов',
  ],
  F2: [
    'Сложение и вычитание на абакусе 2-3D10R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 2D*2D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 4D/1D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 1D7R, 40 примеров, 1 минута, 10 баллов',
    'Сложение и вычитание Ментально 1-2D5R, 40 примеров, 1 минута, 10 баллов',
  ],
  F1: [
    'Сложение и вычитание на абакусе 3-4D10R, 40 примеров, 3 минуты, 10 баллов',
    'Умножение на абакусе 3D*3D, 40 примеров, 3 минуты, 5 баллов',
    'Деление на абакусе 4-5D/2D, 40 примеров, 3 минуты, 5 баллов',
    'Сложение и вычитание Ментально 2D6R, 40 примеров, 1 минута, 10 баллов',
    'Ментальное умножение 2D*1D и деление 3D/1D, 40 примеров, 1 минута, 5 баллов',
  ],
};

export const categories = {
  A13: {
    year: [2019, 2017],
    ru2: `Сложение и вычитание на Абакусе 1D5RNF;
Сложение и вычитание на Абакусе 2D3RNF;
Ментальное сложение и вычитание 1D3RNF;
Флешкарты 1D.`,
    en2: `Addition and subtraction on the Abacus 1D5RNF;
Addition and subtraction on the Abacus 2D3RNF;
Mental addition and subtraction 1D3RNF;
Flash cards 1D.`,
  },
  A12: {
    year: [2019, 2017],
    ru2: `Сложение и вычитание на Абакусе 1D6RF5;
Сложение и вычитание на Абакусе 2D3RNF;
Ментальное сложение и вычитание 1D4RNF;
Флешкарты 2D.`,
    en2: `Addition and subtraction on the Abacus 1D6RF5;
Addition and subtraction on the Abacus 2D3RNF;
Mental addition and subtraction 1D4RNF;
Flash cards 2D.`,
  },
  A11: {
    year: [2019, 2017],
    ru2: `Сложение и вычитание на абакусе 1D8RF10;
Сложение и вычитание на абакусе 2D4RF5;
Сложение и вычитание Ментально 1D5RNF;
Сложение и вычитание Ментально 1D3F5.`,
    en2: `Addition and subtraction on the Abacus 1D8RF10;
Addition and subtraction on the Abacus 2D4RF5;
Mental addition and subtraction 1D5RNF;
Mental addition and subtraction 1D3F5.`,
  },
  A: {
    year: [2019, 2017],
    ru2: `Сложение и вычитание на Абакусе 2D4R;
Умножение на Абакусе 2D*1D;
Сложение и вычитание на Абакусе 1D8R;
Ментальное сложение и вычитание 1D4R;
Ментальное сложение и вычитание 1D5R;
Таблица умножения.`,
    en2: `Addition and subtraction on the Abacus 2D4R;
Multiplication on the Abacus 2D*1D;
Addition and subtraction on the Abacus 1D8R;
Mental addition and subtraction 1D4R;
Mental addition and subtraction 1D5R;
Multiplication table.`,
  },
  AS: {
    year: [2019, 2017],
    ru2: `Сложение и вычитание на абакусе 2D4R;
Сложение и вычитание на абакусе 1D8R;
Умножение на абакусе 2D*1D;
Сложение и вычитание Ментально 1D4R;
Таблица умножения, 40 примеров;
Сложение и вычитание Ментально 1D5R.`,
    en2: `Addition and subtraction on the Abacus 2D4R;
Addition and subtraction on the Abacus 1D8R;
Multiplication on the Abacus 2D*1D;
Mental addition and subtraction 1D4R;
Multiplication table;
Mental addition and subtraction 1D5R.`,
  },
  AP: {
    year: [2019, 2017],
    ru2: `Сложение и вычитание на абакусе 2D6R;
Умножение на абакусе 3D*1D;
Деление на абакусе 3D/1D;
Сложение и вычитание Ментально 1D6R;
Таблица умножения;
Таблица деления.`,
    en2: `Addition and subtraction on the Abacus 2D6R;
Multiplication on the Abacus 3D*1D;
Division on the Abacus 3D/1D;
Mental addition and subtraction 1D6R;
Multiplication table;
Division table`,
  },
  B12: {
    year: [2016, 2015],
    ru2: `Сложение и вычитание на Абакусе 1D6RF5;
Сложение и вычитание на Абакусе 2D3RNF;
Ментальное сложение и вычитание 1D4RNF;
Флешкарты 2D.`,
    en2: `Addition and subtraction on the Abacus 1D6RF5;
Addition and subtraction on the Abacus 2D3RNF;
Mental addition and subtraction 1D4RNF;
Flash cards 2D.`,
  },
  B10: {
    year: [2016, 2015],
    ru2: `Сложение и вычитание на Абакусе 1D10R;
Сложение и вычитание на Абакусе 2D4RF5;
Ментальное сложение и вычитание 1D5RF5;
Ментальное сложение и вычитание 1D4RF10.`,
    en2: `Addition and subtraction on the Abacus 1D10R;
Addition and subtraction on the Abacus 2D4RF5;
Mental addition and subtraction 1D5RF5;
Mental addition and subtraction 1D4RF10.`,
  },
  B: {
    year: [2016, 2015],
    ru2: `Сложение и вычитание на Абакусе 2D10R;
Умножение на Абакусе 3D*1D;
Деление на Абакусе 3D/1D;
Ментальное сложение и вычитание 1D6R;
Ментальное сложение и вычитание 1-2D4R;
Таблица умножения и деления.`,
    en2: `Addition and subtraction on the Abacus 2D10R;
Multiplication on the Abacus 3D*1D;
Division  on the Abacus 3D/1D;
Mental addition and subtraction 1D6R;
Mental addition and subtraction 1-2D4R;
Multiplication and division table.`,
  },
  BS: {
    year: [2016, 2015],
    ru2: `Сложение и вычитание на Абакусе 2D10R;
Умножение на Абакусе 3D*1D;
Деление на Абакусе 3D/1D;
Ментальное сложение и вычитание 1D6R;
Ментальное сложение и вычитание 1-2D4R;
Таблица умножения и деления.`,
    en2: `Addition and subtraction on the Abacus 2D10R;
Multiplication on the Abacus 3D*1D;
Division on the Abacus 3D/1D;
Mental addition and subtraction 1D6R;
Mental addition and subtraction 1-2D4R;
Multiplication and division table.`,
  },
  BP: {
    year: [2016, 2015],
    ru2: `Сложение и вычитание на абакусе 2-3D10R;
Умножение на абакусе 2D*2D;
Деление на абакусе 4D/1D;
Сложение и вычитание Ментально 1D7R;
Таблица умножения;
Таблица деления.`,
    en2: `Addition and subtraction on the Abacus 2-3D10R;
Multiplication on the Abacus 2D*2D;
Division on the Abacus 4D/1D;
Mental addition and subtraction 1D7R;
Multiplication table;
Division table`,
  },
  C12: {
    year: [2014, 2013],
    ru2: `Сложение и вычитание на Абакусе 1D6RF5;
Сложение и вычитание на Абакусе 2D3RNF;
Ментальное сложение и вычитание 1D4RNF;
Флешкарты 2D.`,
    en2: `Addition and subtraction on the Abacus 1D6RF5;
Addition and subtraction on the Abacus 2D3RNF;
Mental addition and subtraction 1D4RNF;
Flash cards 2D.`,
  },
  C10: {
    year: [2014, 2013],
    ru2: `Сложение и вычитание на Абакусе 1D10R;
Сложение и вычитание на Абакусе 2D4RF5;
Ментальное сложение и вычитание 1D5RF5;
Ментальное сложение и вычитание 1D4RF10`,
    en2: `Addition and subtraction on the Abacus 1D10R;
Addition and subtraction on the Abacus 2D4RF5;
Mental addition and subtraction 1D5RF5;
Mental addition and subtraction 1D4RF10.`,
  },
  C8: {
    year: [2014, 2013],
    ru2: `Сложение и вычитание на Абакусе 2D10R;
Умножение на Абакусе 3D*1D;
Деление на Абакусе 3D/1D;
Ментальное сложение и вычитание 1D6R;
Ментальное сложение и вычитание 1-2D4R.`,
    en2: `Addition and subtraction on the Abacus 2D10R;
Multiplication on the Abacus 3D*1D;
Division  on the Abacus 3D/1D;
Mental addition and subtraction 1D6R;
Mental addition and subtraction 1-2D4R.`,
  },
  CS: {
    year: [2014, 2013],
    ru2: `Сложение и вычитание на Абакусе 2-3D10R;
Умножение на Абакусе 2D*2D;
Деление на Абакусе 4D/1D;
Ментальное сложение и вычитание 1D7R;
Ментальное сложение и вычитание 1-2D5R;
Таблица умножения и деления.`,
    en2: `Addition and subtraction on the Abacus 2-3D10R;
Multiplication on the Abacus 2D*2D;
Division  on the Abacus 4D/1D;
Mental addition and subtraction 1D7R;
Mental addition and subtraction 1-2D5R;
Multiplication and division table.`,
  },
  CP: {
    year: [2014, 2013],
    ru2: `Сложение и вычитание на абакусе 2-4D10R, десятичные дроби;
Умножение на абакусе 2D*3D, 3D*2D;
Деление на абакусе 3-4D/1D;
Сложение и вычитание Ментально 2D4R;
Умножение ментально 2D*1D;
Деление ментально 3D/1D.`,
    en2: `Addition and subtraction on the Abacus 2-4D10R, decimals;
Multiplication on the Abacus 2D*3D, 3D*2D;
Division on the Abacus 3-4D/1D;
Mental addition and subtraction 2D4R;
Mental multiplication 2D*1D;
Mental division 3D/1D.`,
  },
  D12: {
    year: [2012, 2011],
    ru2: `Сложение и вычитание на Абакусе 1D6RF5;
Сложение и вычитание на Абакусе 2D3RNF;
Таблица умножения;
Ментальное сложение и вычитание 1D4RNF;
Флешкарты 2D;
Таблица умножения и деления.`,
    en2: `Addition and subtraction on the Abacus 1D6RF5;
Addition and subtraction on the Abacus 2D3RNF;
Multiplication table;
Mental addition and subtraction 1D4RNF;
Flash cards 2D;
Multiplication and division table.`,
  },
  D10: {
    year: [2012, 2011],
    ru2: `Сложение и вычитание на Абакусе 1D10R;
Сложение и вычитание на Абакусе 2D4RF5;
Ментальное сложение и вычитание 1D5RF5;
Ментальное сложение и вычитание 1D4RF10;
Таблица умножения и деления.`,
    en2: `Addition and subtraction on the Abacus 1D10R;
Addition and subtraction on the Abacus 2D4RF5;
Mental addition and subtraction 1D5RF5;
Mental addition and subtraction 1D4RF10;
Multiplication and division table.`,
  },
  D9: {
    year: [2012, 2011],
    ru2: `Сложение и вычитание на Абакусе 2D4R;
Сложение и вычитание на Абакусе 1D8R;
Умножение на Абакусе 2D*1D;
Ментальное сложение и вычитание 1D4R;
Таблица умножения;
Ментальное сложение и вычитание 1D5R.`,
    en2: `Addition and subtraction on the Abacus 2D4R;
    Addition and subtraction on the Abacus 1D8R;
Multiplication on the Abacus 2D*1D;
Mental addition and subtraction 1D4R;
Multiplication table;
Mental addition and subtraction 1D5R.`,
  },
  D7: {
    year: [2012, 2011],
    ru2: `Сложение и вычитание на Абакусе 2-3D10R;
Умножение на Абакусе 2D*2D;
Деление на Абакусе 4D/1D;
Ментальное сложение и вычитание 1D7R;
Ментальное сложение и вычитание 1-2D5R;
Таблица умножения и деления.`,
    en2: `Addition and subtraction on the Abacus 2-3D10R;
Multiplication on the Abacus 2D*2D;
Division  on the Abacus 4D/1D;
Mental addition and subtraction 1D7R;
Mental addition and subtraction 1-2D5R;
Multiplication and division table.`,
  },
  D: {
    year: [2012, 2011],
    ru2: `Сложение и вычитание на Абакусе 2-4D10R;
Умножение на Абакусе 3D*2D;
Деление на Абакусе 4D/2D;
Ментальное сложение и вычитание 2D4R;
Ментальное умножение 2D*1D;
Ментальное деление 3D/1D.`,
    en2: `Addition and subtraction on the Abacus 2-4D10R;
Multiplication  on the Abacus 3D*2D;
Division  on the Abacus 4D/2D;
Mental addition and subtraction 2D4R;
Mental multiplication 2D*1D;
Mental division 3D/1D.`,
  },
  DS: {
    year: [2012, 2011],
    ru2: `Сложение и вычитание на Абакусе 2-4D10R;
Умножение на Абакусе 3D*2D;
Деление на Абакусе 4D/2D;
Ментальное сложение и вычитание 2D4R;
Ментальное умножение 2D*1D;
Ментальное деление 3D/1D.`,
    en2: `Addition and subtraction on the Abacus 2-4D10R;
Multiplication  on the Abacus 3D*2D;
Division  on the Abacus 4D/2D;
Mental addition and subtraction 2D4R;
Mental multiplication 2D*1D;
Mental division 3D/1D.`,
  },
  DP: {
    year: [2012, 2011],
    ru2: `Сложение и вычитание на абакусе 3-4D10R, десятичные дроби;
Умножение на абакусе 2D*4D, 4D*2D, 3D*3D;
Деление на абакусе 4-5D/2D, 4-5D/3D;
Сложение и вычитание Ментально 2D6R;
Ментальное умножение 3D*1D;
Ментальное деление 3D/1D.`,
    en2: `Addition and subtraction on the Abacus 3-4D10R, decimals;
Multiplication on the Abacus 2D*4D, 4D*2D, 3D*3D;
Division on the Abacus 4-5D/2D, 4-5D/3D;
Mental addition and subtraction 2D6R;
Mental multiplication 3D*1D;
Mental division 3D/1D.`,
  },
  E9: {
    year: [2010, 2006],
    ru2: `Сложение и вычитание на Абакусе 2D4R;
Умножение на Абакусе 2D*1D;
Сложение и вычитание на Абакусе 1D8R;
Ментальное сложение и вычитание 1D4R;
Ментальное сложение и вычитание 1D5R;
Таблица умножения.`,
    en2: `Addition and subtraction on the Abacus 2D4R;
Multiplication on the Abacus 2D*1D;
Addition and subtraction on the Abacus 1D8R;
Mental addition and subtraction 1D4R;
Mental addition and subtraction 1D5R;
Multiplication table.`,
  },
  E7: {
    year: [2010, 2006],
    ru2: `Сложение и вычитание на Абакусе 2-3D10R;
Умножение на Абакусе 2D*2D;
Деление на Абакусе 4D/1D;
Ментальное сложение и вычитание 1D7R;
Ментальное сложение и вычитание 1-2D5R;
Таблица умножения и деления.`,
    en2: `Addition and subtraction on the Abacus 2-3D10R;
Multiplication on the Abacus 2D*2D;
Division  on the Abacus 4D/1D;
Mental addition and subtraction 1D7R;
Mental addition and subtraction 1-2D5R;
Multiplication and division table.`,
  },
  E: {
    year: [2010, 2006],
    ru2: `Сложение и вычитание на Абакусе 3-4D10R;
Умножение на Абакусе 3D3D;
Деление на Абакусе 5D/2-3D;
Ментальное сложение и вычитание 2D6R;
Ментальное умножение 3D*1D;
Ментальное деление 3D/1D.`,
    en2: `Addition and subtraction on the Abacus 3-4D10R;
Multiplication on the Abacus 3D3D;
Division  on the Abacus 5D/2-3D;
Mental addition and subtraction 2D6R;
Mental multiplication 3D*1D;
Mental division 3D/1D.`,
  },
  ES: {
    year: [2010, 2006],
    ru2: `Сложение и вычитание на Абакусе 3-4D10R;
Умножение на Абакусе 3D*3D, 4D*2D, 2D*4D;
Деление на Абакусе 5D/2-3D;
Ментальное сложение и вычитание 2D6R;
Ментальное умножение 3D*1D;
Ментальное деление 3D/1D.`,
    en2: `Addition and subtraction on the Abacus 3-4D10R;
Multiplication on the Abacus 3D*3D, 4D*2D, 2D*4D;
Division  on the Abacus 5D/2-3D;
Mental addition and subtraction 2D6R;
Mental multiplication 3D*1D;
Mental division 3D/1D.`,
  },
  F3: {
    ru2: `Сложение и вычитание на Абакусе 1-2D10R;
Ментальное сложение и вычитание 1D6R;
Таблица умножения и деления.`,
    en2: `Addition and subtraction on the Abacus 1-2D10R;
Mental addition and subtraction 1D6R;
Multiplication and division table.`,
  },
  F2: {
    ru2: `Сложение и вычитание на Абакусе 2-3D10R;
Умножение на Абакусе 2D*2D;
Деление на Абакусе 4D/1D;
Ментальное сложение и вычитание 1D7R;
Ментальное сложение и вычитание 1-2D5R.`,
    en2: `Addition and subtraction on the Abacus 2-3D10R;
Multiplication on the Abacus 2D*2D;
Division  on the Abacus 4D/1D;
Mental addition and subtraction 1D7R;
Mental addition and subtraction 1-2D5R.`,
  },
  F1: {
    ru2: `Сложение и вычитание на Абакусе 3-4D10R;
Умножение на Абакусе 3D*3D;
Деление на Абакусе 5D/2-3D;
Ментальное сложение и вычитание 2D6R;
Ментальное умножение 3D*1D;
Ментальное деление 3D/1D.`,
    en2: `Addition and subtraction on the Abacus 3-4D10R;
Multiplication on the Abacus 3D*3D;
Division  on the Abacus 5D/2-3D;
Mental addition and subtraction 2D6R;
Mental multiplication 3D*1D;
Mental division 3D/1D.`,
  },
};

/**
- 4-6 лет (до 128 см)
- 6-7 лет 130-140
- 7-9 лет 140-150
- 9-11 лет 150-160
- S
- М
- L
- XL
 */

export const sizes = [
  {
    value: null,
    label: 'Есть синяя UAMAP',
  },
  {
    value: '4',
    label: '4-6 лет (до 128 см)',
  },
  {
    value: '6',
    label: '6-7 лет (130 - 140 см)',
  },
  {
    value: '8',
    label: '7-9 лет (140 - 150 см)',
  },
  {
    value: '10',
    label: '9-11 лет (150 - 160 см)',
  },
  {
    value: 'S',
    label: 'S',
  },
  {
    value: 'M',
    label: 'M',
  },
  {
    value: 'L',
    label: 'L',
  },
  {
    value: 'XL',
    label: 'XL',
  },
];

// ------PAMA очная------

// конфиг для PAMA offline (без params — только для регистрации)
export const pamaOfflineSettings = [
  { name: 'A', years: [2024, 2023, 2022, 2021, 2020, 2019] },
  { name: 'B', years: [2018, 2017] },
  { name: 'C', years: [2016, 2015] },
  { name: 'D', years: [2014, 2013] },
  { name: 'E', years: [2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005, 2004] },
  { name: 'F', years: [] }, // для учителей/педагогов
];
// Размеры футболок PAMA
export const pamaSizes = [
  {
    value: '1',
    label: 'до 130 см (3XS)',
  },
  {
    value: '2',
    label: '140 см (2XS)',
  },
  {
    value: '3',
    label: '150 см (XS)',
  },
  {
    value: 'M',
    label: 'M',
  },
  {
    value: 'L',
    label: 'L',
  },
  {
    value: 'XL',
    label: 'XL',
  },
];
